import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import { alpha, useTheme } from '@mui/material/styles';
import Container from '../../../../components/Container';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../view-home.css';
import SearchInput from '../../../Search/components/SearchInput';

const OcpfPhotos = [
  {
    title: "OCPF1",
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic1.png',
  },
  {
    title: 'OCPF2',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic2.png',
  },
  {
    title: 'OCPF3',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic3.png',
  },
  {
    title: 'OCPF4',
    img: 'https://ocpf2.blob.core.windows.net/website-content/homepage-slider/homepage_slider_pic4.png',
  }
];



const Hero = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  
  const LeftSide = () => (
    <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
      <Box marginBottom={2}>
        <Typography
          color={'primary.ocpfBlue'}
          component={'span'}
          variant="h4"
          fontWeight={500}
        >
          Welcome to the Massachusetts Office of Campaign and Political Finance
        </Typography>
      </Box>
      <Box marginBottom={3}>
        <Typography variant="h6" component="p" color="text.secondary">
        OCPF is an independent agency charged with overseeing compliance with the campaign finance law.
        </Typography>
      </Box>
      <Box display="flex" flexDirection={'column'} justifyContent={'center'}>
        <Box marginBottom={2}></Box>
        <Box
        padding={1}
        width={1}
        component={Card}
        boxShadow={4}
        marginBottom={0}
        sx={{
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            bgcolor: 'background.paper',
            padding: '0 !important',
          },
        }}
      >  
        <Box display="flex" alignItems={'center'}>
            <Box width={1} marginRight={1}>
              <SearchInput></SearchInput>
            </Box>
        </Box>
      </Box>
      </Box>
    </Box>
  );

  const RightSide = (item: any): JSX.Element => {
    return (
      <Box
        sx={{
        height: { xs: 'auto', md: 1 },
        '& img': {
          objectFit: 'cover',
        },
        }}
      >
        <Box
          role='presentation'
          component={'img'}
          loading="lazy"
          src={item.img}
          height={{ xs: 'auto', md: 1 }}
          maxHeight={{ xs: 200, md: 1 }}
          width={1}
          maxWidth={1}
        />
      </Box>
    );
  };

  return (
    <Box
      sx={{
        bgcolor: 'alternate.main',
        width: 1,
        height: 1,
        marginTop:3,
        //overflow: 'hidden',
      }}
      className="homepage-hero"
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          position={'relative'}
        >
          <Box width={1} order={{ xs: 2, md: 1 }}>
            <Container>
              <LeftSide />
            </Container>
          </Box>
          <Box
            sx={{
              flex: { xs: '0 0 100%', md: '0 0 50%' },
              position: 'relative',
              maxWidth: { xs: '100%', md: '50%' },
              order: { xs: 1, md: 2 },
            }}
          >
            <Box
              sx={{
                width: { xs: 1, md: '50vw' },
                height: '100%',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  //overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    //overflow: 'hidden',
                    left: '0%',
                    width: 1,
                    height: 1,
                    position: { xs: 'relative', md: 'absolute' },
                    clipPath: {
                      xs: 'none',
                      md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                    },
                    shapeOutside: {
                      xs: 'none',
                      md: 'polygon(10% 0%, 100% 0, 100% 100%, 0% 100%)',
                    },
                  }}
                >
                  <Slider {...sliderSettings}>
                    {OcpfPhotos.map((item, index) => (
                      <Box key={index} height={1} width={1}>
                        {RightSide(item)}
                      </Box>
                    ))}
                  </Slider>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
      <Divider />
    </Box>
  );
};

export default Hero;
